import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IStaffDetails} from '../staff-details';
import { Observable } from 'rxjs/Observable';
interface myData{
  success : boolean,
  message : string
}
@Injectable({
  providedIn: 'root'
})

export class StaffService {

  constructor(private http : HttpClient) { }
  getStaffEvaluationQuestions(){
    return this.http.get('/edozzier/portal-staff-evaluation-questions.php');
  }

  getStaffDetails():Observable<IStaffDetails[]>{
    return this.http.get<IStaffDetails[]>('/edozzier/portal-staff-evaluation-details.php');
  }

  saveEvaluationQuestions(data){
    return this.http.post<myData>('/edozzier/portal-save-evaluation-questions.php', data);

  }

  getAllStaff(){
    return this.http.get<any>('/edozzier/portal-staff-details.php');
  }
}
